import React from "react";
import { Box } from "@mui/material";

// Shared tab panel + a11y helpers used by the settings tabs (MainSettingsView)
// and the nested feature sub-tabs (OrganizationFeaturesTab). The active panel is
// conditionally rendered (value === index), which the dirty-state aggregation relies on.

export function CustomTabPanel(props) {
  const { children, value, index, idPrefix = "settings", ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-tabpanel-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
      {...other}
      style={{ overflow: "hidden", maxWidth: "100%" }}
    >
      {value === index && (
        <Box sx={{ py: { xs: 2, md: 3 }, px: { xs: 0, md: 3 }, overflow: "hidden", maxWidth: "100%" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export function a11yProps(index, idPrefix = "settings") {
  return {
    id: `${idPrefix}-tab-${index}`,
    "aria-controls": `${idPrefix}-tabpanel-${index}`,
  };
}
